import { Table } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

export const UsersTableHead: React.FC = () => {
  const { t } = useTranslation('settings')

  return (
    <Table.Head>
      <Table.Head.Row>
        <Table.Head.Cell className="w-max">
          {t('manageUsers.userHeader')}
        </Table.Head.Cell>
        <Table.Head.Cell className="w-1/6">
          {t('personalInfo.role')}
        </Table.Head.Cell>
        <Table.Head.Cell className="w-1/3">
          {t('manageUsers.statusHeader')}
        </Table.Head.Cell>
        <Table.Head.Cell className="w-16">
          {/* Column for action menu */}
        </Table.Head.Cell>
      </Table.Head.Row>
    </Table.Head>
  )
}
